import { render, staticRenderFns } from "./profit.renderer.vue?vue&type=template&id=e3828e3e&scoped=true&"
import script from "./profit.renderer.vue?vue&type=script&lang=js&"
export * from "./profit.renderer.vue?vue&type=script&lang=js&"
import style0 from "./profit.renderer.vue?vue&type=style&index=0&id=e3828e3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3828e3e",
  null
  
)

export default component.exports